import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-baseline-near_me-24px",
  "use": "icon-baseline-near_me-24px-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-baseline-near_me-24px\">\n    <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n    <path d=\"M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol